import { capitalize } from "lodash";

import { getInfo } from "@Components/Grid/components/Table/formatters";

export default function LevelFormatter({ info }) {
  const { row } = getInfo(info)
  const { level } = row

  if (!level) {
    return "--"
  }

  return <>{capitalize(level)}</>
}
